import { useNavigate } from "react-router-dom";
import { APP_CONFIG } from "../utils/api";

export default function UnauthScreen() {
  const navigate = useNavigate();

  const courseName = APP_CONFIG.brandName;

  return (
    <main className="min-h-screen w-full flex flex-col bg-white">
      <section className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="rounded-2xl border border-gray-200 shadow-[0_6px_24px_rgba(0,0,0,0.06)] p-6 md:p-8">
            <h1 className="text-2xl font-bold text-center mb-2">{courseName}</h1>
            <p className="text-gray-500 text-sm text-center mb-8">Добро пожаловать</p>

            <div className="flex flex-col gap-3">
              <button
                onClick={() => navigate("/auth/otp")}
                className="w-full bg-black text-white rounded-lg py-3 font-bold transition active:scale-95"
              >
                У меня есть доступ
              </button>
              <button
                onClick={() => navigate("/")}
                className="w-full border border-black text-black rounded-lg py-3 font-semibold transition active:scale-95"
              >
                Купить курс
              </button>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
